<template>
	<section class="redirect-view">
		<ui-button @click="redirect">Return To App</ui-button>
	</section>
</template>

<script>
import UiButton from '../../ui/Button'
export default {
	name: 'redirect-view',
	components: { UiButton },
	methods: {
		redirect() {
			window.location = 'roundupapp://accounts'
		}
	}
}
</script>

<style lang="scss">
.redirect-view {
	padding: 20px;
}
</style>
